import { getEnvVar } from "common/utilities/ generic";
import logger from "../common/utilities/logger";
import { ErrorCodes } from "./constants/errorCodes";
import errorHandler from "./helper/errorHandler";

// eslint-disable-next-line no-use-before-define
let fetchQuoteWidget = fetchQuoteWidget || window.fetchQuoteWidget || null;

(function () {
    if (fetchQuoteWidget && window.fetchQuoteWidget && window._env_) return;

    let defaultConfig = {
        tag: "",
    };

    fetchQuoteWidget = {
        onInit(response, error) {
            return { response, error };
        },

        onComplete() {},

        on(func, callback) {
            const eventMapper = {
                init: "onInit",
                ready: "onReady",
                complete: "onComplete",
                invoke: "invoke",
                getElement: "getElement",
                renderPaymentForm: "renderPaymentForm",
                closeModal: "closeModal",
            };

            this[eventMapper[func]] = callback;
        },

        init(options) {
            try {
                defaultConfig = { ...defaultConfig, ...options };

                const response = errorHandler.init(options);

                this.onInit(response, {});
            } catch (error) {
                logger.error(error.message, error);

                this.onInit({}, error);
            }
        },

        invoke(options) {
            try {
                defaultConfig = { ...defaultConfig, ...options };

                errorHandler.initiateSdk(options);

                this.renderPaymentForm();
            } catch (error) {
                fetchQuoteWidget.onComplete(null, error);
            }
        },

        getElement() {
            const elById = document.getElementById(defaultConfig.tag);
            const elByName = document.getElementsByName(defaultConfig.tag);
            return elById || (elByName?.length && elByName[0]);
        },

        renderPaymentForm() {
            const el = this.getElement();

            const style =
                "position:absolute; top:0; left:0; bottom:0; right:0; width:100%; height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;";
            const iframe = document.createElement("iframe");

            iframe.setAttribute("style", style);
            iframe.setAttribute("title", "salesFunnel-Quote-sdk");
            iframe.setAttribute("src", getEnvVar("REACT_APP_FRONTEND_HOST"));
            iframe.setAttribute("width", "100%");
            iframe.setAttribute("height", "100%");
            iframe.setAttribute("frameBorder", "0");
            iframe.setAttribute("scrolling", "auto");

            el.appendChild(iframe);

            let pollingCount = 0;
            const timerId = setInterval(() => {
                const payload = { ...defaultConfig, queryParams: window.location.search };

                const targetHost = getEnvVar("REACT_APP_FRONTEND_HOST") || "*";

                iframe.contentWindow.postMessage(payload, targetHost);
                if (pollingCount >= 5) {
                    clearInterval(timerId);
                }
                pollingCount++;
            }, 800);

            return true;
        },

        closeModal() {
            const el = this.getElement();
            el.innerHTML = null;
            return true;
        },
    };

    setTimeout(() => {
        fetchQuoteWidget.onReady();
    }, 100);

    // Listen to events fired from page
    window.onmessage = function (event) {
        const origin = event.origin || event?.originalEvent?.origin;
        if (origin !== getEnvVar("REACT_APP_FRONTEND_HOST")) return;

        switch (event?.data?.event) {
            case "salesFunnel-Quote-sdk-success":
                fetchQuoteWidget.onComplete(event?.data?.data, null);
                fetchQuoteWidget.closeModal();
                return;
            case "salesFunnel-Quote-sdk-failed":
                fetchQuoteWidget.onComplete(null, ErrorCodes?.QuoteFailed);
                fetchQuoteWidget.closeModal();
                return;
            case "salesFunnel-Quote-sdk-cancelled":
                fetchQuoteWidget.onComplete(null, ErrorCodes?.sdkFailed);
                fetchQuoteWidget.closeModal();
                return;
            case "close-modal":
                fetchQuoteWidget.closeModal();
                return;
            default:
                return;
        }
    };

    window.fetchQuoteWidget = fetchQuoteWidget;
})();
